import { createSlice } from "@reduxjs/toolkit";
import { questionnareErrorInitial } from "./initialState";


// localityList can be [],
// setExpiryDate 1 when expirydate is selected. otherwise 0. Expiryadate should not be selected
const initialState: any = questionnareErrorInitial;

const questionnaireErrorSlice = createSlice({
    name: "questionnareError",
    initialState,
    reducers: {
        upDateQuestionnareErrors: (state, action) => {
            const currentQuestionnare: any = { ...state }
            const errorArray = action.payload;
            for (let field of errorArray) {
                if (field.includes('question-')) {
                    currentQuestionnare.objectiveQuestions = [...currentQuestionnare.objectiveQuestions, Number(field.substring(9))] //question-.length is 9
                }
                else {
                    currentQuestionnare[field] = true
                }
            }
            return currentQuestionnare

        },
        resetQuestionnareErrors: (state, action) => {
            const { field, value = null } = action.payload;
            if (field === 'objectiveQuestions') {
                const filteredQs = [...state.objectiveQuestions].filter((i: any) => i !== value)
                return {
                    ...state, objectiveQuestions: filteredQs
                }
            }
            else {
                return {
                    ...state, [field]: false
                }
            }

        }
    },
});

export const { upDateQuestionnareErrors, resetQuestionnareErrors } =
    questionnaireErrorSlice.actions;
export default questionnaireErrorSlice;
